function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Map } from '@googlemaps/react-wrapper';
import { Image, Skeleton, Tag, Button, Space, Modal, Drawer } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import { GoogleMap, Marker, useLoadScript, useJsApiLoader } from "@react-google-maps/api";
import { PenFill, TrashFill, ArrowRight } from "react-bootstrap-icons";
import { useMemo } from "react";
import Common from "../components/includes/Common";
import ContestView from "../components/ContestView";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Vote = function Vote() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    contestList = _useState4[0],
    setContestList = _useState4[1];
  var _useState5 = useState(12),
    _useState6 = _slicedToArray(_useState5, 2),
    limit = _useState6[0],
    setLimit = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    offset = _useState8[0],
    setOffset = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedContest = _useState10[0],
    setSelectedContest = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showContestDetails = _useState12[0],
    setShowContestDetails = _useState12[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcontests/' + limit.toString() + '/' + offset.toString()).then(function (response) {
      setIsDataLoading(false);
      if (response.data.status == 200) {
        setContestList([]);
        setContestList(response.data.contests);
      }
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      style: {
        marginTop: "25px"
      },
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(Image, {
            width: "100%",
            src: "drawables/vote.png",
            preview: false,
            style: {
              borderRadius: "7px ",
              marginBottom: "10px"
            }
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: Common.currentUser && Common.currentUser.role == 901 && /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(Row, {
              children: contestList.map(function (e) {
                return /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  sm: 6,
                  className: "white-bg feed-box",
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      sm: 5,
                      xs: 5,
                      children: /*#__PURE__*/_jsx("img", {
                        src: e.cover_url,
                        style: {
                          width: '100%'
                        }
                      })
                    }), /*#__PURE__*/_jsxs(Col, {
                      lg: 8,
                      md: 8,
                      sm: 7,
                      xs: 7,
                      children: [/*#__PURE__*/_jsx("h6", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: e.label
                        })
                      }), /*#__PURE__*/_jsxs(Tag, {
                        color: "#f50",
                        children: [e.contest_milestones.length, " Etapes"]
                      }), /*#__PURE__*/_jsx("p", {
                        children: e.description
                      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Space, {
                        direction: "vertical",
                        children: /*#__PURE__*/_jsx(Space, {
                          direction: "horizontal",
                          style: {
                            clear: "both"
                          },
                          children: /*#__PURE__*/_jsxs(Button, {
                            icon: /*#__PURE__*/_jsx(ArrowRight, {}),
                            type: "primary",
                            href: "/#/home/vote/" + e.id,
                            children: [" ", /*#__PURE__*/_jsx("b", {
                              children: "ENTRER"
                            })]
                          })
                        })
                      }), /*#__PURE__*/_jsx("br", {})]
                    })]
                  })
                }, e.id);
              })
            })
          })
        })
      })]
    })
  });
};
export default Vote;